import { Link, Translation } from '@ps/web-shared-components';
import type { ReactNode } from 'react';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import {
  type ComplexBetSlipErrorConfig,
  isResolverTagLink
} from '@swf/sports/config/bet-slip-errors';

import styles from './TranslationWithLink.scss';

const TranslationWithLink: React.FC<ComplexBetSlipErrorConfig> = ({
  contentTranslationTag,
  link
}) => {
  if (!link) {
    return <Translation {...contentTranslationTag} />;
  }

  return (
    <Translation
      values={{
        a: (linkText: ReactNode) =>
          isResolverTagLink(link) ? (
            <ResolverLink resolverTag={link.resolverTag} className={styles.link}>
              {linkText}
            </ResolverLink>
          ) : (
            <Link alias={link.alias} className={styles.link} values={link.params}>
              {linkText}
            </Link>
          )
      }}
      {...contentTranslationTag}
    />
  );
};

export default TranslationWithLink;
